module.exports = __webpack_public_path__ + "img/RECUADRO_Acompaniamiento.e94db20b.png";